import { pairingSources } from "src/modules/pairing/constants";
import { cancelDevicePairing } from "src/modules/pairing/ajax/cloud";
import * as selectors from "../../duck/selectors";
import { resetState } from "../actions";

export default function handlePairingCancelation({ flow, closeWizard }) {
  return (dispatch, getState) => {
    const state = getState();
    const request = selectors.getRequest(state);
    const pairingSource = selectors.getPairingSource(state);

    if (request?.requestId) cancelDevicePairing(request.requestId);

    if (typeof closeWizard === "function") {
      closeWizard();
      return;
    }

    if (flow == null) {
      return;
    }

    dispatch(resetState());
    pairingSource === pairingSources.AUTO_PAIRING
      ? flow.push("nearby-devices", { direction: "previous" })
      : flow.push("scan-qr-code", { direction: "previous" });
  };
}
